import { render } from "./PositionTraining.vue?vue&type=template&id=7df3a1be&ts=true"
import script from "./PositionTraining.vue?vue&type=script&lang=ts"
export * from "./PositionTraining.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__